export default `
precision highp float;

uniform sampler2D u_texture;
uniform vec2 u_resolution;

uniform float u_pass;
uniform float u_random_seed;

const int N_MAX = 100;
uniform float u_N;

varying vec2 v_texCoord;


vec4 get_pixel(float dx, float dy) {
    vec2 pos = v_texCoord * u_resolution + vec2(dx, dy);
    pos.x = mod(pos.x, u_resolution.x);
    pos.y = mod(pos.y, u_resolution.y);
    return texture2D(
        u_texture,
        pos / u_resolution
    );
}

float get_value(float dx, float dy) {
    vec4 pixel = get_pixel(dx, dy) * 255.0;
    // The 255.0 on pixel.w is intentional
    return (pixel.x + (pixel.y + (pixel.z + pixel.w/255.0)/256.0)/256.0)/256.0;
}

vec4 encode(float value) {
    vec4 encoded = vec4(0.0, 0.0, 0.0, 0.0);
    for (int i = 0; i < 4; i++) {
        value *= 256.0;
        float pixel = floor(value);
        value -= pixel;
        encoded[i] = pixel/255.0;
    }
    // To account for rounding bias
    encoded[3] += value/255.0;
    return encoded;
}

float rand(vec2 co) {
    return fract(sin(dot(co.xy, vec2(12.9898,78.233))) * 43758.5453);
}

void main() {
    if (u_pass > 0.5) {
        // Display texture to canvas
        gl_FragColor = vec4(get_pixel(0.0, 0.0).xxx, 1.0);
    } else {
        // Apply kernel
        float value = 0.0;
        for (int i = 0; i < N_MAX; i++) {
            float i_float = float(i);
            if (i_float < u_N - 0.5) {
                float x = rand(vec2(u_random_seed, i_float)) * u_resolution.x;
                float y = rand(vec2(u_random_seed + 1.0, i_float)) * u_resolution.y;
                value += get_value(x, y);
            }
        }
        value /= u_N;

        gl_FragColor = encode(value);
    }
}
`;
